module.exports = __webpack_public_path__ + "static/media/pin_map.06c5c850.svg";